(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// packages/alpinejs/src/scheduler.js
var $cc64e8f951c5c19e$var$flushPending = false;
var $cc64e8f951c5c19e$var$flushing = false;
var $cc64e8f951c5c19e$var$queue = [];
var $cc64e8f951c5c19e$var$lastFlushedIndex = -1;
function $cc64e8f951c5c19e$var$scheduler(callback) {
    $cc64e8f951c5c19e$var$queueJob(callback);
}
function $cc64e8f951c5c19e$var$queueJob(job) {
    if (!$cc64e8f951c5c19e$var$queue.includes(job)) $cc64e8f951c5c19e$var$queue.push(job);
    $cc64e8f951c5c19e$var$queueFlush();
}
function $cc64e8f951c5c19e$var$dequeueJob(job) {
    let index = $cc64e8f951c5c19e$var$queue.indexOf(job);
    if (index !== -1 && index > $cc64e8f951c5c19e$var$lastFlushedIndex) $cc64e8f951c5c19e$var$queue.splice(index, 1);
}
function $cc64e8f951c5c19e$var$queueFlush() {
    if (!$cc64e8f951c5c19e$var$flushing && !$cc64e8f951c5c19e$var$flushPending) {
        $cc64e8f951c5c19e$var$flushPending = true;
        queueMicrotask($cc64e8f951c5c19e$var$flushJobs);
    }
}
function $cc64e8f951c5c19e$var$flushJobs() {
    $cc64e8f951c5c19e$var$flushPending = false;
    $cc64e8f951c5c19e$var$flushing = true;
    for(let i = 0; i < $cc64e8f951c5c19e$var$queue.length; i++){
        $cc64e8f951c5c19e$var$queue[i]();
        $cc64e8f951c5c19e$var$lastFlushedIndex = i;
    }
    $cc64e8f951c5c19e$var$queue.length = 0;
    $cc64e8f951c5c19e$var$lastFlushedIndex = -1;
    $cc64e8f951c5c19e$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $cc64e8f951c5c19e$var$reactive;
var $cc64e8f951c5c19e$var$effect;
var $cc64e8f951c5c19e$var$release;
var $cc64e8f951c5c19e$var$raw;
var $cc64e8f951c5c19e$var$shouldSchedule = true;
function $cc64e8f951c5c19e$var$disableEffectScheduling(callback) {
    $cc64e8f951c5c19e$var$shouldSchedule = false;
    callback();
    $cc64e8f951c5c19e$var$shouldSchedule = true;
}
function $cc64e8f951c5c19e$var$setReactivityEngine(engine) {
    $cc64e8f951c5c19e$var$reactive = engine.reactive;
    $cc64e8f951c5c19e$var$release = engine.release;
    $cc64e8f951c5c19e$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($cc64e8f951c5c19e$var$shouldSchedule) $cc64e8f951c5c19e$var$scheduler(task);
                else task();
            }
        });
    $cc64e8f951c5c19e$var$raw = engine.raw;
}
function $cc64e8f951c5c19e$var$overrideEffect(override) {
    $cc64e8f951c5c19e$var$effect = override;
}
function $cc64e8f951c5c19e$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $cc64e8f951c5c19e$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $cc64e8f951c5c19e$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $cc64e8f951c5c19e$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $cc64e8f951c5c19e$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$cc64e8f951c5c19e$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $cc64e8f951c5c19e$var$onAttributeAddeds = [];
var $cc64e8f951c5c19e$var$onElRemoveds = [];
var $cc64e8f951c5c19e$var$onElAddeds = [];
function $cc64e8f951c5c19e$var$onElAdded(callback) {
    $cc64e8f951c5c19e$var$onElAddeds.push(callback);
}
function $cc64e8f951c5c19e$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $cc64e8f951c5c19e$var$onElRemoveds.push(callback);
    }
}
function $cc64e8f951c5c19e$var$onAttributesAdded(callback) {
    $cc64e8f951c5c19e$var$onAttributeAddeds.push(callback);
}
function $cc64e8f951c5c19e$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $cc64e8f951c5c19e$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $cc64e8f951c5c19e$var$cleanupElement(el) {
    if (el._x_cleanups) while(el._x_cleanups.length)el._x_cleanups.pop()();
}
var $cc64e8f951c5c19e$var$observer = new MutationObserver($cc64e8f951c5c19e$var$onMutate);
var $cc64e8f951c5c19e$var$currentlyObserving = false;
function $cc64e8f951c5c19e$var$startObservingMutations() {
    $cc64e8f951c5c19e$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $cc64e8f951c5c19e$var$currentlyObserving = true;
}
function $cc64e8f951c5c19e$var$stopObservingMutations() {
    $cc64e8f951c5c19e$var$flushObserver();
    $cc64e8f951c5c19e$var$observer.disconnect();
    $cc64e8f951c5c19e$var$currentlyObserving = false;
}
var $cc64e8f951c5c19e$var$queuedMutations = [];
function $cc64e8f951c5c19e$var$flushObserver() {
    let records = $cc64e8f951c5c19e$var$observer.takeRecords();
    $cc64e8f951c5c19e$var$queuedMutations.push(()=>records.length > 0 && $cc64e8f951c5c19e$var$onMutate(records));
    let queueLengthWhenTriggered = $cc64e8f951c5c19e$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($cc64e8f951c5c19e$var$queuedMutations.length === queueLengthWhenTriggered) while($cc64e8f951c5c19e$var$queuedMutations.length > 0)$cc64e8f951c5c19e$var$queuedMutations.shift()();
    });
}
function $cc64e8f951c5c19e$var$mutateDom(callback) {
    if (!$cc64e8f951c5c19e$var$currentlyObserving) return callback();
    $cc64e8f951c5c19e$var$stopObservingMutations();
    let result = callback();
    $cc64e8f951c5c19e$var$startObservingMutations();
    return result;
}
var $cc64e8f951c5c19e$var$isCollecting = false;
var $cc64e8f951c5c19e$var$deferredMutations = [];
function $cc64e8f951c5c19e$var$deferMutations() {
    $cc64e8f951c5c19e$var$isCollecting = true;
}
function $cc64e8f951c5c19e$var$flushAndStopDeferringMutations() {
    $cc64e8f951c5c19e$var$isCollecting = false;
    $cc64e8f951c5c19e$var$onMutate($cc64e8f951c5c19e$var$deferredMutations);
    $cc64e8f951c5c19e$var$deferredMutations = [];
}
function $cc64e8f951c5c19e$var$onMutate(mutations) {
    if ($cc64e8f951c5c19e$var$isCollecting) {
        $cc64e8f951c5c19e$var$deferredMutations = $cc64e8f951c5c19e$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = /* @__PURE__ */ new Set();
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.add(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.add(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $cc64e8f951c5c19e$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $cc64e8f951c5c19e$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.has(node)) continue;
        $cc64e8f951c5c19e$var$onElRemoveds.forEach((i)=>i(node));
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.has(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $cc64e8f951c5c19e$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $cc64e8f951c5c19e$var$scope(node) {
    return $cc64e8f951c5c19e$var$mergeProxies($cc64e8f951c5c19e$var$closestDataStack(node));
}
function $cc64e8f951c5c19e$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$cc64e8f951c5c19e$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $cc64e8f951c5c19e$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $cc64e8f951c5c19e$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $cc64e8f951c5c19e$var$closestDataStack(node.parentNode);
}
function $cc64e8f951c5c19e$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $cc64e8f951c5c19e$var$mergeProxyTrap);
}
var $cc64e8f951c5c19e$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $cc64e8f951c5c19e$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return Reflect.set(target, name, value, thisProxy);
        return Reflect.set(target, name, value);
    }
};
function $cc64e8f951c5c19e$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $cc64e8f951c5c19e$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $cc64e8f951c5c19e$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$cc64e8f951c5c19e$var$get(data2, path), (value)=>$cc64e8f951c5c19e$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $cc64e8f951c5c19e$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $cc64e8f951c5c19e$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $cc64e8f951c5c19e$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $cc64e8f951c5c19e$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $cc64e8f951c5c19e$var$magics = {};
function $cc64e8f951c5c19e$var$magic(name, callback) {
    $cc64e8f951c5c19e$var$magics[name] = callback;
}
function $cc64e8f951c5c19e$var$injectMagics(obj, el) {
    Object.entries($cc64e8f951c5c19e$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $cc64e8f951c5c19e$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $cc64e8f951c5c19e$var$interceptor,
                    ...utilities
                };
                $cc64e8f951c5c19e$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $cc64e8f951c5c19e$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $cc64e8f951c5c19e$var$handleError(e, el, expression);
    }
}
function $cc64e8f951c5c19e$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $cc64e8f951c5c19e$var$shouldAutoEvaluateFunctions = true;
function $cc64e8f951c5c19e$var$dontAutoEvaluateFunctions(callback) {
    let cache = $cc64e8f951c5c19e$var$shouldAutoEvaluateFunctions;
    $cc64e8f951c5c19e$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $cc64e8f951c5c19e$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $cc64e8f951c5c19e$var$evaluate(el, expression, extras = {}) {
    let result;
    $cc64e8f951c5c19e$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $cc64e8f951c5c19e$var$evaluateLater(...args) {
    return $cc64e8f951c5c19e$var$theEvaluatorFunction(...args);
}
var $cc64e8f951c5c19e$var$theEvaluatorFunction = $cc64e8f951c5c19e$var$normalEvaluator;
function $cc64e8f951c5c19e$var$setEvaluator(newEvaluator) {
    $cc64e8f951c5c19e$var$theEvaluatorFunction = newEvaluator;
}
function $cc64e8f951c5c19e$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $cc64e8f951c5c19e$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$cc64e8f951c5c19e$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $cc64e8f951c5c19e$var$generateEvaluatorFromFunction(dataStack, expression) : $cc64e8f951c5c19e$var$generateEvaluatorFromString(dataStack, expression, el);
    return $cc64e8f951c5c19e$var$tryCatch.bind(null, el, expression, evaluator);
}
function $cc64e8f951c5c19e$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($cc64e8f951c5c19e$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $cc64e8f951c5c19e$var$runIfTypeOfFunction(receiver, result);
    };
}
var $cc64e8f951c5c19e$var$evaluatorMemo = {};
function $cc64e8f951c5c19e$var$generateFunctionFromString(expression, el) {
    if ($cc64e8f951c5c19e$var$evaluatorMemo[expression]) return $cc64e8f951c5c19e$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $cc64e8f951c5c19e$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $cc64e8f951c5c19e$var$evaluatorMemo[expression] = func;
    return func;
}
function $cc64e8f951c5c19e$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $cc64e8f951c5c19e$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $cc64e8f951c5c19e$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$cc64e8f951c5c19e$var$handleError(error2, el, expression));
            if (func.finished) {
                $cc64e8f951c5c19e$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $cc64e8f951c5c19e$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$cc64e8f951c5c19e$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $cc64e8f951c5c19e$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($cc64e8f951c5c19e$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$cc64e8f951c5c19e$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$cc64e8f951c5c19e$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $cc64e8f951c5c19e$var$prefixAsString = "x-";
function $cc64e8f951c5c19e$var$prefix(subject = "") {
    return $cc64e8f951c5c19e$var$prefixAsString + subject;
}
function $cc64e8f951c5c19e$var$setPrefix(newPrefix) {
    $cc64e8f951c5c19e$var$prefixAsString = newPrefix;
}
var $cc64e8f951c5c19e$var$directiveHandlers = {};
function $cc64e8f951c5c19e$var$directive(name, callback) {
    $cc64e8f951c5c19e$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$cc64e8f951c5c19e$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $cc64e8f951c5c19e$var$directiveOrder.indexOf(directive2);
            $cc64e8f951c5c19e$var$directiveOrder.splice(pos >= 0 ? pos : $cc64e8f951c5c19e$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $cc64e8f951c5c19e$var$directiveExists(name) {
    return Object.keys($cc64e8f951c5c19e$var$directiveHandlers).includes(name);
}
function $cc64e8f951c5c19e$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $cc64e8f951c5c19e$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($cc64e8f951c5c19e$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($cc64e8f951c5c19e$var$outNonAlpineAttributes).map($cc64e8f951c5c19e$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($cc64e8f951c5c19e$var$byPriority);
    return directives2.map((directive2)=>{
        return $cc64e8f951c5c19e$var$getDirectiveHandler(el, directive2);
    });
}
function $cc64e8f951c5c19e$var$attributesOnly(attributes) {
    return Array.from(attributes).map($cc64e8f951c5c19e$var$toTransformedAttributes()).filter((attr)=>!$cc64e8f951c5c19e$var$outNonAlpineAttributes(attr));
}
var $cc64e8f951c5c19e$var$isDeferringHandlers = false;
var $cc64e8f951c5c19e$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $cc64e8f951c5c19e$var$currentHandlerStackKey = Symbol();
function $cc64e8f951c5c19e$var$deferHandlingDirectives(callback) {
    $cc64e8f951c5c19e$var$isDeferringHandlers = true;
    let key = Symbol();
    $cc64e8f951c5c19e$var$currentHandlerStackKey = key;
    $cc64e8f951c5c19e$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($cc64e8f951c5c19e$var$directiveHandlerStacks.get(key).length)$cc64e8f951c5c19e$var$directiveHandlerStacks.get(key).shift()();
        $cc64e8f951c5c19e$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $cc64e8f951c5c19e$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $cc64e8f951c5c19e$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $cc64e8f951c5c19e$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $cc64e8f951c5c19e$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $cc64e8f951c5c19e$var$evaluateLater.bind($cc64e8f951c5c19e$var$evaluateLater, el),
        evaluate: $cc64e8f951c5c19e$var$evaluate.bind($cc64e8f951c5c19e$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $cc64e8f951c5c19e$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $cc64e8f951c5c19e$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $cc64e8f951c5c19e$var$getElementBoundUtilities(el);
    $cc64e8f951c5c19e$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $cc64e8f951c5c19e$var$isDeferringHandlers ? $cc64e8f951c5c19e$var$directiveHandlerStacks.get($cc64e8f951c5c19e$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $cc64e8f951c5c19e$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $cc64e8f951c5c19e$var$into = (i)=>i;
function $cc64e8f951c5c19e$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $cc64e8f951c5c19e$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $cc64e8f951c5c19e$var$attributeTransformers = [];
function $cc64e8f951c5c19e$var$mapAttributes(callback) {
    $cc64e8f951c5c19e$var$attributeTransformers.push(callback);
}
function $cc64e8f951c5c19e$var$outNonAlpineAttributes({ name: name }) {
    return $cc64e8f951c5c19e$var$alpineAttributeRegex().test(name);
}
var $cc64e8f951c5c19e$var$alpineAttributeRegex = ()=>new RegExp(`^${$cc64e8f951c5c19e$var$prefixAsString}([^:^.]+)\\b`);
function $cc64e8f951c5c19e$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($cc64e8f951c5c19e$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $cc64e8f951c5c19e$var$DEFAULT = "DEFAULT";
var $cc64e8f951c5c19e$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $cc64e8f951c5c19e$var$DEFAULT,
    "teleport"
];
function $cc64e8f951c5c19e$var$byPriority(a, b) {
    let typeA = $cc64e8f951c5c19e$var$directiveOrder.indexOf(a.type) === -1 ? $cc64e8f951c5c19e$var$DEFAULT : a.type;
    let typeB = $cc64e8f951c5c19e$var$directiveOrder.indexOf(b.type) === -1 ? $cc64e8f951c5c19e$var$DEFAULT : b.type;
    return $cc64e8f951c5c19e$var$directiveOrder.indexOf(typeA) - $cc64e8f951c5c19e$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $cc64e8f951c5c19e$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $cc64e8f951c5c19e$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$cc64e8f951c5c19e$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $cc64e8f951c5c19e$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $cc64e8f951c5c19e$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $cc64e8f951c5c19e$var$started = false;
function $cc64e8f951c5c19e$var$start() {
    if ($cc64e8f951c5c19e$var$started) $cc64e8f951c5c19e$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $cc64e8f951c5c19e$var$started = true;
    if (!document.body) $cc64e8f951c5c19e$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $cc64e8f951c5c19e$var$dispatch(document, "alpine:init");
    $cc64e8f951c5c19e$var$dispatch(document, "alpine:initializing");
    $cc64e8f951c5c19e$var$startObservingMutations();
    $cc64e8f951c5c19e$var$onElAdded((el)=>$cc64e8f951c5c19e$var$initTree(el, $cc64e8f951c5c19e$var$walk));
    $cc64e8f951c5c19e$var$onElRemoved((el)=>$cc64e8f951c5c19e$var$destroyTree(el));
    $cc64e8f951c5c19e$var$onAttributesAdded((el, attrs)=>{
        $cc64e8f951c5c19e$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$cc64e8f951c5c19e$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($cc64e8f951c5c19e$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $cc64e8f951c5c19e$var$initTree(el);
    });
    $cc64e8f951c5c19e$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $cc64e8f951c5c19e$var$warnAboutMissingPlugins();
    });
}
var $cc64e8f951c5c19e$var$rootSelectorCallbacks = [];
var $cc64e8f951c5c19e$var$initSelectorCallbacks = [];
function $cc64e8f951c5c19e$var$rootSelectors() {
    return $cc64e8f951c5c19e$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $cc64e8f951c5c19e$var$allSelectors() {
    return $cc64e8f951c5c19e$var$rootSelectorCallbacks.concat($cc64e8f951c5c19e$var$initSelectorCallbacks).map((fn)=>fn());
}
function $cc64e8f951c5c19e$var$addRootSelector(selectorCallback) {
    $cc64e8f951c5c19e$var$rootSelectorCallbacks.push(selectorCallback);
}
function $cc64e8f951c5c19e$var$addInitSelector(selectorCallback) {
    $cc64e8f951c5c19e$var$initSelectorCallbacks.push(selectorCallback);
}
function $cc64e8f951c5c19e$var$closestRoot(el, includeInitSelectors = false) {
    return $cc64e8f951c5c19e$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $cc64e8f951c5c19e$var$allSelectors() : $cc64e8f951c5c19e$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $cc64e8f951c5c19e$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $cc64e8f951c5c19e$var$findClosest(el.parentElement, callback);
}
function $cc64e8f951c5c19e$var$isRoot(el) {
    return $cc64e8f951c5c19e$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $cc64e8f951c5c19e$var$initInterceptors2 = [];
function $cc64e8f951c5c19e$var$interceptInit(callback) {
    $cc64e8f951c5c19e$var$initInterceptors2.push(callback);
}
function $cc64e8f951c5c19e$var$initTree(el, walker = $cc64e8f951c5c19e$var$walk, intercept = ()=>{}) {
    $cc64e8f951c5c19e$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $cc64e8f951c5c19e$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $cc64e8f951c5c19e$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $cc64e8f951c5c19e$var$destroyTree(root, walker = $cc64e8f951c5c19e$var$walk) {
    walker(root, (el)=>{
        $cc64e8f951c5c19e$var$cleanupAttributes(el);
        $cc64e8f951c5c19e$var$cleanupElement(el);
    });
}
function $cc64e8f951c5c19e$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($cc64e8f951c5c19e$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $cc64e8f951c5c19e$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $cc64e8f951c5c19e$var$tickStack = [];
var $cc64e8f951c5c19e$var$isHolding = false;
function $cc64e8f951c5c19e$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $cc64e8f951c5c19e$var$isHolding || setTimeout(()=>{
            $cc64e8f951c5c19e$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $cc64e8f951c5c19e$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $cc64e8f951c5c19e$var$releaseNextTicks() {
    $cc64e8f951c5c19e$var$isHolding = false;
    while($cc64e8f951c5c19e$var$tickStack.length)$cc64e8f951c5c19e$var$tickStack.shift()();
}
function $cc64e8f951c5c19e$var$holdNextTicks() {
    $cc64e8f951c5c19e$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $cc64e8f951c5c19e$var$setClasses(el, value) {
    if (Array.isArray(value)) return $cc64e8f951c5c19e$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $cc64e8f951c5c19e$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $cc64e8f951c5c19e$var$setClasses(el, value());
    return $cc64e8f951c5c19e$var$setClassesFromString(el, value);
}
function $cc64e8f951c5c19e$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $cc64e8f951c5c19e$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $cc64e8f951c5c19e$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $cc64e8f951c5c19e$var$setStylesFromObject(el, value);
    return $cc64e8f951c5c19e$var$setStylesFromString(el, value);
}
function $cc64e8f951c5c19e$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $cc64e8f951c5c19e$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $cc64e8f951c5c19e$var$setStyles(el, previousStyles);
    };
}
function $cc64e8f951c5c19e$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $cc64e8f951c5c19e$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $cc64e8f951c5c19e$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$cc64e8f951c5c19e$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $cc64e8f951c5c19e$var$registerTransitionsFromHelper(el, modifiers, value);
    else $cc64e8f951c5c19e$var$registerTransitionsFromClassString(el, expression, value);
});
function $cc64e8f951c5c19e$var$registerTransitionsFromClassString(el, classString, stage) {
    $cc64e8f951c5c19e$var$registerTransitionObject(el, $cc64e8f951c5c19e$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $cc64e8f951c5c19e$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $cc64e8f951c5c19e$var$registerTransitionObject(el, $cc64e8f951c5c19e$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $cc64e8f951c5c19e$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $cc64e8f951c5c19e$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $cc64e8f951c5c19e$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $cc64e8f951c5c19e$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $cc64e8f951c5c19e$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $cc64e8f951c5c19e$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $cc64e8f951c5c19e$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $cc64e8f951c5c19e$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $cc64e8f951c5c19e$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $cc64e8f951c5c19e$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $cc64e8f951c5c19e$var$closestHide(parent);
}
function $cc64e8f951c5c19e$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $cc64e8f951c5c19e$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $cc64e8f951c5c19e$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $cc64e8f951c5c19e$var$once(()=>{
        $cc64e8f951c5c19e$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $cc64e8f951c5c19e$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $cc64e8f951c5c19e$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $cc64e8f951c5c19e$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $cc64e8f951c5c19e$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $cc64e8f951c5c19e$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $cc64e8f951c5c19e$var$mutateDom(()=>{
                stages.end();
            });
            $cc64e8f951c5c19e$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $cc64e8f951c5c19e$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $cc64e8f951c5c19e$var$isCloning = false;
function $cc64e8f951c5c19e$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$cc64e8f951c5c19e$var$isCloning ? fallback(...args) : callback(...args);
}
function $cc64e8f951c5c19e$var$onlyDuringClone(callback) {
    return (...args)=>$cc64e8f951c5c19e$var$isCloning && callback(...args);
}
var $cc64e8f951c5c19e$var$interceptors = [];
function $cc64e8f951c5c19e$var$interceptClone(callback) {
    $cc64e8f951c5c19e$var$interceptors.push(callback);
}
function $cc64e8f951c5c19e$var$cloneNode(from, to) {
    $cc64e8f951c5c19e$var$interceptors.forEach((i)=>i(from, to));
    $cc64e8f951c5c19e$var$isCloning = true;
    $cc64e8f951c5c19e$var$dontRegisterReactiveSideEffects(()=>{
        $cc64e8f951c5c19e$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $cc64e8f951c5c19e$var$isCloning = false;
}
var $cc64e8f951c5c19e$var$isCloningLegacy = false;
function $cc64e8f951c5c19e$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $cc64e8f951c5c19e$var$isCloning = true;
    $cc64e8f951c5c19e$var$isCloningLegacy = true;
    $cc64e8f951c5c19e$var$dontRegisterReactiveSideEffects(()=>{
        $cc64e8f951c5c19e$var$cloneTree(newEl);
    });
    $cc64e8f951c5c19e$var$isCloning = false;
    $cc64e8f951c5c19e$var$isCloningLegacy = false;
}
function $cc64e8f951c5c19e$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $cc64e8f951c5c19e$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $cc64e8f951c5c19e$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $cc64e8f951c5c19e$var$initTree(el, shallowWalker);
}
function $cc64e8f951c5c19e$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $cc64e8f951c5c19e$var$effect;
    $cc64e8f951c5c19e$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $cc64e8f951c5c19e$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $cc64e8f951c5c19e$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $cc64e8f951c5c19e$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $cc64e8f951c5c19e$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $cc64e8f951c5c19e$var$camelCase(name) : name;
    switch(name){
        case "value":
            $cc64e8f951c5c19e$var$bindInputValue(el, value);
            break;
        case "style":
            $cc64e8f951c5c19e$var$bindStyles(el, value);
            break;
        case "class":
            $cc64e8f951c5c19e$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $cc64e8f951c5c19e$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $cc64e8f951c5c19e$var$bindAttribute(el, name, value);
            break;
    }
}
function $cc64e8f951c5c19e$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $cc64e8f951c5c19e$var$safeParseBoolean(el.value) === value;
            else el.checked = $cc64e8f951c5c19e$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$cc64e8f951c5c19e$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $cc64e8f951c5c19e$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $cc64e8f951c5c19e$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $cc64e8f951c5c19e$var$setClasses(el, value);
}
function $cc64e8f951c5c19e$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $cc64e8f951c5c19e$var$setStyles(el, value);
}
function $cc64e8f951c5c19e$var$bindAttributeAndProperty(el, name, value) {
    $cc64e8f951c5c19e$var$bindAttribute(el, name, value);
    $cc64e8f951c5c19e$var$setPropertyIfChanged(el, name, value);
}
function $cc64e8f951c5c19e$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $cc64e8f951c5c19e$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($cc64e8f951c5c19e$var$isBooleanAttr(name)) value = name;
        $cc64e8f951c5c19e$var$setIfChanged(el, name, value);
    }
}
function $cc64e8f951c5c19e$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $cc64e8f951c5c19e$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $cc64e8f951c5c19e$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $cc64e8f951c5c19e$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $cc64e8f951c5c19e$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $cc64e8f951c5c19e$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
function $cc64e8f951c5c19e$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $cc64e8f951c5c19e$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $cc64e8f951c5c19e$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $cc64e8f951c5c19e$var$getAttributeBinding(el, name, fallback);
}
function $cc64e8f951c5c19e$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $cc64e8f951c5c19e$var$dontAutoEvaluateFunctions(()=>{
            return $cc64e8f951c5c19e$var$evaluate(el, binding.expression);
        });
    }
    return $cc64e8f951c5c19e$var$getAttributeBinding(el, name, fallback);
}
function $cc64e8f951c5c19e$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($cc64e8f951c5c19e$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $cc64e8f951c5c19e$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $cc64e8f951c5c19e$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $cc64e8f951c5c19e$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $cc64e8f951c5c19e$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($cc64e8f951c5c19e$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($cc64e8f951c5c19e$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($cc64e8f951c5c19e$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $cc64e8f951c5c19e$var$release(reference);
    };
}
function $cc64e8f951c5c19e$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $cc64e8f951c5c19e$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($cc64e8f951c5c19e$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $cc64e8f951c5c19e$var$stores = {};
var $cc64e8f951c5c19e$var$isReactive = false;
function $cc64e8f951c5c19e$var$store(name, value) {
    if (!$cc64e8f951c5c19e$var$isReactive) {
        $cc64e8f951c5c19e$var$stores = $cc64e8f951c5c19e$var$reactive($cc64e8f951c5c19e$var$stores);
        $cc64e8f951c5c19e$var$isReactive = true;
    }
    if (value === void 0) return $cc64e8f951c5c19e$var$stores[name];
    $cc64e8f951c5c19e$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $cc64e8f951c5c19e$var$stores[name].init();
    $cc64e8f951c5c19e$var$initInterceptors($cc64e8f951c5c19e$var$stores[name]);
}
function $cc64e8f951c5c19e$var$getStores() {
    return $cc64e8f951c5c19e$var$stores;
}
// packages/alpinejs/src/binds.js
var $cc64e8f951c5c19e$var$binds = {};
function $cc64e8f951c5c19e$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $cc64e8f951c5c19e$var$applyBindingsObject(name, getBindings());
    else $cc64e8f951c5c19e$var$binds[name] = getBindings;
    return ()=>{};
}
function $cc64e8f951c5c19e$var$injectBindingProviders(obj) {
    Object.entries($cc64e8f951c5c19e$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $cc64e8f951c5c19e$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $cc64e8f951c5c19e$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $cc64e8f951c5c19e$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $cc64e8f951c5c19e$var$datas = {};
function $cc64e8f951c5c19e$var$data(name, callback) {
    $cc64e8f951c5c19e$var$datas[name] = callback;
}
function $cc64e8f951c5c19e$var$injectDataProviders(obj, context) {
    Object.entries($cc64e8f951c5c19e$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $cc64e8f951c5c19e$var$Alpine = {
    get reactive () {
        return $cc64e8f951c5c19e$var$reactive;
    },
    get release () {
        return $cc64e8f951c5c19e$var$release;
    },
    get effect () {
        return $cc64e8f951c5c19e$var$effect;
    },
    get raw () {
        return $cc64e8f951c5c19e$var$raw;
    },
    version: "3.13.10",
    flushAndStopDeferringMutations: $cc64e8f951c5c19e$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $cc64e8f951c5c19e$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $cc64e8f951c5c19e$var$disableEffectScheduling,
    startObservingMutations: $cc64e8f951c5c19e$var$startObservingMutations,
    stopObservingMutations: $cc64e8f951c5c19e$var$stopObservingMutations,
    setReactivityEngine: $cc64e8f951c5c19e$var$setReactivityEngine,
    onAttributeRemoved: $cc64e8f951c5c19e$var$onAttributeRemoved,
    onAttributesAdded: $cc64e8f951c5c19e$var$onAttributesAdded,
    closestDataStack: $cc64e8f951c5c19e$var$closestDataStack,
    skipDuringClone: $cc64e8f951c5c19e$var$skipDuringClone,
    onlyDuringClone: $cc64e8f951c5c19e$var$onlyDuringClone,
    addRootSelector: $cc64e8f951c5c19e$var$addRootSelector,
    addInitSelector: $cc64e8f951c5c19e$var$addInitSelector,
    interceptClone: $cc64e8f951c5c19e$var$interceptClone,
    addScopeToNode: $cc64e8f951c5c19e$var$addScopeToNode,
    deferMutations: $cc64e8f951c5c19e$var$deferMutations,
    mapAttributes: $cc64e8f951c5c19e$var$mapAttributes,
    evaluateLater: $cc64e8f951c5c19e$var$evaluateLater,
    interceptInit: $cc64e8f951c5c19e$var$interceptInit,
    setEvaluator: $cc64e8f951c5c19e$var$setEvaluator,
    mergeProxies: $cc64e8f951c5c19e$var$mergeProxies,
    extractProp: $cc64e8f951c5c19e$var$extractProp,
    findClosest: $cc64e8f951c5c19e$var$findClosest,
    onElRemoved: $cc64e8f951c5c19e$var$onElRemoved,
    closestRoot: $cc64e8f951c5c19e$var$closestRoot,
    destroyTree: $cc64e8f951c5c19e$var$destroyTree,
    interceptor: $cc64e8f951c5c19e$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $cc64e8f951c5c19e$var$transition,
    setStyles: // INTERNAL
    $cc64e8f951c5c19e$var$setStyles,
    mutateDom: // INTERNAL
    $cc64e8f951c5c19e$var$mutateDom,
    directive: $cc64e8f951c5c19e$var$directive,
    entangle: $cc64e8f951c5c19e$var$entangle,
    throttle: $cc64e8f951c5c19e$var$throttle,
    debounce: $cc64e8f951c5c19e$var$debounce,
    evaluate: $cc64e8f951c5c19e$var$evaluate,
    initTree: $cc64e8f951c5c19e$var$initTree,
    nextTick: $cc64e8f951c5c19e$var$nextTick,
    prefixed: $cc64e8f951c5c19e$var$prefix,
    prefix: $cc64e8f951c5c19e$var$setPrefix,
    plugin: $cc64e8f951c5c19e$var$plugin,
    magic: $cc64e8f951c5c19e$var$magic,
    store: $cc64e8f951c5c19e$var$store,
    start: $cc64e8f951c5c19e$var$start,
    clone: $cc64e8f951c5c19e$var$clone,
    cloneNode: // INTERNAL
    $cc64e8f951c5c19e$var$cloneNode,
    // INTERNAL
    bound: $cc64e8f951c5c19e$var$getBinding,
    $data: $cc64e8f951c5c19e$var$scope,
    watch: $cc64e8f951c5c19e$var$watch,
    walk: $cc64e8f951c5c19e$var$walk,
    data: $cc64e8f951c5c19e$var$data,
    bind: $cc64e8f951c5c19e$var$bind2
};
var $cc64e8f951c5c19e$var$alpine_default = $cc64e8f951c5c19e$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $cc64e8f951c5c19e$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $cc64e8f951c5c19e$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $cc64e8f951c5c19e$var$isBooleanAttr2 = /* @__PURE__ */ $cc64e8f951c5c19e$var$makeMap($cc64e8f951c5c19e$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $cc64e8f951c5c19e$var$EMPTY_OBJ = Object.freeze({});
var $cc64e8f951c5c19e$var$EMPTY_ARR = Object.freeze([]);
var $cc64e8f951c5c19e$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $cc64e8f951c5c19e$var$hasOwn = (val, key)=>$cc64e8f951c5c19e$var$hasOwnProperty.call(val, key);
var $cc64e8f951c5c19e$var$isArray = Array.isArray;
var $cc64e8f951c5c19e$var$isMap = (val)=>$cc64e8f951c5c19e$var$toTypeString(val) === "[object Map]";
var $cc64e8f951c5c19e$var$isString = (val)=>typeof val === "string";
var $cc64e8f951c5c19e$var$isSymbol = (val)=>typeof val === "symbol";
var $cc64e8f951c5c19e$var$isObject = (val)=>val !== null && typeof val === "object";
var $cc64e8f951c5c19e$var$objectToString = Object.prototype.toString;
var $cc64e8f951c5c19e$var$toTypeString = (value)=>$cc64e8f951c5c19e$var$objectToString.call(value);
var $cc64e8f951c5c19e$var$toRawType = (value)=>{
    return $cc64e8f951c5c19e$var$toTypeString(value).slice(8, -1);
};
var $cc64e8f951c5c19e$var$isIntegerKey = (key)=>$cc64e8f951c5c19e$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $cc64e8f951c5c19e$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $cc64e8f951c5c19e$var$camelizeRE = /-(\w)/g;
var $cc64e8f951c5c19e$var$camelize = $cc64e8f951c5c19e$var$cacheStringFunction((str)=>{
    return str.replace($cc64e8f951c5c19e$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $cc64e8f951c5c19e$var$hyphenateRE = /\B([A-Z])/g;
var $cc64e8f951c5c19e$var$hyphenate = $cc64e8f951c5c19e$var$cacheStringFunction((str)=>str.replace($cc64e8f951c5c19e$var$hyphenateRE, "-$1").toLowerCase());
var $cc64e8f951c5c19e$var$capitalize = $cc64e8f951c5c19e$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $cc64e8f951c5c19e$var$toHandlerKey = $cc64e8f951c5c19e$var$cacheStringFunction((str)=>str ? `on${$cc64e8f951c5c19e$var$capitalize(str)}` : ``);
var $cc64e8f951c5c19e$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $cc64e8f951c5c19e$var$targetMap = /* @__PURE__ */ new WeakMap();
var $cc64e8f951c5c19e$var$effectStack = [];
var $cc64e8f951c5c19e$var$activeEffect;
var $cc64e8f951c5c19e$var$ITERATE_KEY = Symbol("iterate");
var $cc64e8f951c5c19e$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $cc64e8f951c5c19e$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $cc64e8f951c5c19e$var$effect2(fn, options = $cc64e8f951c5c19e$var$EMPTY_OBJ) {
    if ($cc64e8f951c5c19e$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $cc64e8f951c5c19e$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $cc64e8f951c5c19e$var$stop(effect3) {
    if (effect3.active) {
        $cc64e8f951c5c19e$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $cc64e8f951c5c19e$var$uid = 0;
function $cc64e8f951c5c19e$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$cc64e8f951c5c19e$var$effectStack.includes(effect3)) {
            $cc64e8f951c5c19e$var$cleanup(effect3);
            try {
                $cc64e8f951c5c19e$var$enableTracking();
                $cc64e8f951c5c19e$var$effectStack.push(effect3);
                $cc64e8f951c5c19e$var$activeEffect = effect3;
                return fn();
            } finally{
                $cc64e8f951c5c19e$var$effectStack.pop();
                $cc64e8f951c5c19e$var$resetTracking();
                $cc64e8f951c5c19e$var$activeEffect = $cc64e8f951c5c19e$var$effectStack[$cc64e8f951c5c19e$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $cc64e8f951c5c19e$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $cc64e8f951c5c19e$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $cc64e8f951c5c19e$var$shouldTrack = true;
var $cc64e8f951c5c19e$var$trackStack = [];
function $cc64e8f951c5c19e$var$pauseTracking() {
    $cc64e8f951c5c19e$var$trackStack.push($cc64e8f951c5c19e$var$shouldTrack);
    $cc64e8f951c5c19e$var$shouldTrack = false;
}
function $cc64e8f951c5c19e$var$enableTracking() {
    $cc64e8f951c5c19e$var$trackStack.push($cc64e8f951c5c19e$var$shouldTrack);
    $cc64e8f951c5c19e$var$shouldTrack = true;
}
function $cc64e8f951c5c19e$var$resetTracking() {
    const last = $cc64e8f951c5c19e$var$trackStack.pop();
    $cc64e8f951c5c19e$var$shouldTrack = last === void 0 ? true : last;
}
function $cc64e8f951c5c19e$var$track(target, type, key) {
    if (!$cc64e8f951c5c19e$var$shouldTrack || $cc64e8f951c5c19e$var$activeEffect === void 0) return;
    let depsMap = $cc64e8f951c5c19e$var$targetMap.get(target);
    if (!depsMap) $cc64e8f951c5c19e$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($cc64e8f951c5c19e$var$activeEffect)) {
        dep.add($cc64e8f951c5c19e$var$activeEffect);
        $cc64e8f951c5c19e$var$activeEffect.deps.push(dep);
        if ($cc64e8f951c5c19e$var$activeEffect.options.onTrack) $cc64e8f951c5c19e$var$activeEffect.options.onTrack({
            effect: $cc64e8f951c5c19e$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $cc64e8f951c5c19e$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $cc64e8f951c5c19e$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $cc64e8f951c5c19e$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $cc64e8f951c5c19e$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$cc64e8f951c5c19e$var$isArray(target)) {
                    add2(depsMap.get($cc64e8f951c5c19e$var$ITERATE_KEY));
                    if ($cc64e8f951c5c19e$var$isMap(target)) add2(depsMap.get($cc64e8f951c5c19e$var$MAP_KEY_ITERATE_KEY));
                } else if ($cc64e8f951c5c19e$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$cc64e8f951c5c19e$var$isArray(target)) {
                    add2(depsMap.get($cc64e8f951c5c19e$var$ITERATE_KEY));
                    if ($cc64e8f951c5c19e$var$isMap(target)) add2(depsMap.get($cc64e8f951c5c19e$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($cc64e8f951c5c19e$var$isMap(target)) add2(depsMap.get($cc64e8f951c5c19e$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $cc64e8f951c5c19e$var$isNonTrackableKeys = /* @__PURE__ */ $cc64e8f951c5c19e$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $cc64e8f951c5c19e$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($cc64e8f951c5c19e$var$isSymbol));
var $cc64e8f951c5c19e$var$get2 = /* @__PURE__ */ $cc64e8f951c5c19e$var$createGetter();
var $cc64e8f951c5c19e$var$readonlyGet = /* @__PURE__ */ $cc64e8f951c5c19e$var$createGetter(true);
var $cc64e8f951c5c19e$var$arrayInstrumentations = /* @__PURE__ */ $cc64e8f951c5c19e$var$createArrayInstrumentations();
function $cc64e8f951c5c19e$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $cc64e8f951c5c19e$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$cc64e8f951c5c19e$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($cc64e8f951c5c19e$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $cc64e8f951c5c19e$var$pauseTracking();
            const res = $cc64e8f951c5c19e$var$toRaw(this)[key].apply(this, args);
            $cc64e8f951c5c19e$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $cc64e8f951c5c19e$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $cc64e8f951c5c19e$var$shallowReadonlyMap : $cc64e8f951c5c19e$var$readonlyMap : shallow ? $cc64e8f951c5c19e$var$shallowReactiveMap : $cc64e8f951c5c19e$var$reactiveMap).get(target)) return target;
        const targetIsArray = $cc64e8f951c5c19e$var$isArray(target);
        if (!isReadonly && targetIsArray && $cc64e8f951c5c19e$var$hasOwn($cc64e8f951c5c19e$var$arrayInstrumentations, key)) return Reflect.get($cc64e8f951c5c19e$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($cc64e8f951c5c19e$var$isSymbol(key) ? $cc64e8f951c5c19e$var$builtInSymbols.has(key) : $cc64e8f951c5c19e$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $cc64e8f951c5c19e$var$track(target, "get", key);
        if (shallow) return res;
        if ($cc64e8f951c5c19e$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$cc64e8f951c5c19e$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($cc64e8f951c5c19e$var$isObject(res)) return isReadonly ? $cc64e8f951c5c19e$var$readonly(res) : $cc64e8f951c5c19e$var$reactive2(res);
        return res;
    };
}
var $cc64e8f951c5c19e$var$set2 = /* @__PURE__ */ $cc64e8f951c5c19e$var$createSetter();
function $cc64e8f951c5c19e$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $cc64e8f951c5c19e$var$toRaw(value);
            oldValue = $cc64e8f951c5c19e$var$toRaw(oldValue);
            if (!$cc64e8f951c5c19e$var$isArray(target) && $cc64e8f951c5c19e$var$isRef(oldValue) && !$cc64e8f951c5c19e$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $cc64e8f951c5c19e$var$isArray(target) && $cc64e8f951c5c19e$var$isIntegerKey(key) ? Number(key) < target.length : $cc64e8f951c5c19e$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $cc64e8f951c5c19e$var$toRaw(receiver)) {
            if (!hadKey) $cc64e8f951c5c19e$var$trigger(target, "add", key, value);
            else if ($cc64e8f951c5c19e$var$hasChanged(value, oldValue)) $cc64e8f951c5c19e$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $cc64e8f951c5c19e$var$deleteProperty(target, key) {
    const hadKey = $cc64e8f951c5c19e$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $cc64e8f951c5c19e$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $cc64e8f951c5c19e$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$cc64e8f951c5c19e$var$isSymbol(key) || !$cc64e8f951c5c19e$var$builtInSymbols.has(key)) $cc64e8f951c5c19e$var$track(target, "has", key);
    return result;
}
function $cc64e8f951c5c19e$var$ownKeys(target) {
    $cc64e8f951c5c19e$var$track(target, "iterate", $cc64e8f951c5c19e$var$isArray(target) ? "length" : $cc64e8f951c5c19e$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $cc64e8f951c5c19e$var$mutableHandlers = {
    get: $cc64e8f951c5c19e$var$get2,
    set: $cc64e8f951c5c19e$var$set2,
    deleteProperty: $cc64e8f951c5c19e$var$deleteProperty,
    has: $cc64e8f951c5c19e$var$has,
    ownKeys: $cc64e8f951c5c19e$var$ownKeys
};
var $cc64e8f951c5c19e$var$readonlyHandlers = {
    get: $cc64e8f951c5c19e$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $cc64e8f951c5c19e$var$toReactive = (value)=>$cc64e8f951c5c19e$var$isObject(value) ? $cc64e8f951c5c19e$var$reactive2(value) : value;
var $cc64e8f951c5c19e$var$toReadonly = (value)=>$cc64e8f951c5c19e$var$isObject(value) ? $cc64e8f951c5c19e$var$readonly(value) : value;
var $cc64e8f951c5c19e$var$toShallow = (value)=>value;
var $cc64e8f951c5c19e$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $cc64e8f951c5c19e$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $cc64e8f951c5c19e$var$toRaw(target);
    const rawKey = $cc64e8f951c5c19e$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $cc64e8f951c5c19e$var$track(rawTarget, "get", key);
    !isReadonly && $cc64e8f951c5c19e$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $cc64e8f951c5c19e$var$getProto(rawTarget);
    const wrap = isShallow ? $cc64e8f951c5c19e$var$toShallow : isReadonly ? $cc64e8f951c5c19e$var$toReadonly : $cc64e8f951c5c19e$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $cc64e8f951c5c19e$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $cc64e8f951c5c19e$var$toRaw(target);
    const rawKey = $cc64e8f951c5c19e$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $cc64e8f951c5c19e$var$track(rawTarget, "has", key);
    !isReadonly && $cc64e8f951c5c19e$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $cc64e8f951c5c19e$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $cc64e8f951c5c19e$var$track($cc64e8f951c5c19e$var$toRaw(target), "iterate", $cc64e8f951c5c19e$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $cc64e8f951c5c19e$var$add(value) {
    value = $cc64e8f951c5c19e$var$toRaw(value);
    const target = $cc64e8f951c5c19e$var$toRaw(this);
    const proto = $cc64e8f951c5c19e$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $cc64e8f951c5c19e$var$trigger(target, "add", value, value);
    }
    return this;
}
function $cc64e8f951c5c19e$var$set$1(key, value) {
    value = $cc64e8f951c5c19e$var$toRaw(value);
    const target = $cc64e8f951c5c19e$var$toRaw(this);
    const { has: has2, get: get3 } = $cc64e8f951c5c19e$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $cc64e8f951c5c19e$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $cc64e8f951c5c19e$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $cc64e8f951c5c19e$var$trigger(target, "add", key, value);
    else if ($cc64e8f951c5c19e$var$hasChanged(value, oldValue)) $cc64e8f951c5c19e$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $cc64e8f951c5c19e$var$deleteEntry(key) {
    const target = $cc64e8f951c5c19e$var$toRaw(this);
    const { has: has2, get: get3 } = $cc64e8f951c5c19e$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $cc64e8f951c5c19e$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $cc64e8f951c5c19e$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $cc64e8f951c5c19e$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $cc64e8f951c5c19e$var$clear() {
    const target = $cc64e8f951c5c19e$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $cc64e8f951c5c19e$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $cc64e8f951c5c19e$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $cc64e8f951c5c19e$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $cc64e8f951c5c19e$var$toRaw(target);
        const wrap = isShallow ? $cc64e8f951c5c19e$var$toShallow : isReadonly ? $cc64e8f951c5c19e$var$toReadonly : $cc64e8f951c5c19e$var$toReactive;
        !isReadonly && $cc64e8f951c5c19e$var$track(rawTarget, "iterate", $cc64e8f951c5c19e$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $cc64e8f951c5c19e$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $cc64e8f951c5c19e$var$toRaw(target);
        const targetIsMap = $cc64e8f951c5c19e$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $cc64e8f951c5c19e$var$toShallow : isReadonly ? $cc64e8f951c5c19e$var$toReadonly : $cc64e8f951c5c19e$var$toReactive;
        !isReadonly && $cc64e8f951c5c19e$var$track(rawTarget, "iterate", isKeyOnly ? $cc64e8f951c5c19e$var$MAP_KEY_ITERATE_KEY : $cc64e8f951c5c19e$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $cc64e8f951c5c19e$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$cc64e8f951c5c19e$var$capitalize(type)} operation ${key}failed: target is readonly.`, $cc64e8f951c5c19e$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $cc64e8f951c5c19e$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $cc64e8f951c5c19e$var$get$1(this, key);
        },
        get size () {
            return $cc64e8f951c5c19e$var$size(this);
        },
        has: $cc64e8f951c5c19e$var$has$1,
        add: $cc64e8f951c5c19e$var$add,
        set: $cc64e8f951c5c19e$var$set$1,
        delete: $cc64e8f951c5c19e$var$deleteEntry,
        clear: $cc64e8f951c5c19e$var$clear,
        forEach: $cc64e8f951c5c19e$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $cc64e8f951c5c19e$var$get$1(this, key, false, true);
        },
        get size () {
            return $cc64e8f951c5c19e$var$size(this);
        },
        has: $cc64e8f951c5c19e$var$has$1,
        add: $cc64e8f951c5c19e$var$add,
        set: $cc64e8f951c5c19e$var$set$1,
        delete: $cc64e8f951c5c19e$var$deleteEntry,
        clear: $cc64e8f951c5c19e$var$clear,
        forEach: $cc64e8f951c5c19e$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $cc64e8f951c5c19e$var$get$1(this, key, true);
        },
        get size () {
            return $cc64e8f951c5c19e$var$size(this, true);
        },
        has (key) {
            return $cc64e8f951c5c19e$var$has$1.call(this, key, true);
        },
        add: $cc64e8f951c5c19e$var$createReadonlyMethod("add"),
        set: $cc64e8f951c5c19e$var$createReadonlyMethod("set"),
        delete: $cc64e8f951c5c19e$var$createReadonlyMethod("delete"),
        clear: $cc64e8f951c5c19e$var$createReadonlyMethod("clear"),
        forEach: $cc64e8f951c5c19e$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $cc64e8f951c5c19e$var$get$1(this, key, true, true);
        },
        get size () {
            return $cc64e8f951c5c19e$var$size(this, true);
        },
        has (key) {
            return $cc64e8f951c5c19e$var$has$1.call(this, key, true);
        },
        add: $cc64e8f951c5c19e$var$createReadonlyMethod("add"),
        set: $cc64e8f951c5c19e$var$createReadonlyMethod("set"),
        delete: $cc64e8f951c5c19e$var$createReadonlyMethod("delete"),
        clear: $cc64e8f951c5c19e$var$createReadonlyMethod("clear"),
        forEach: $cc64e8f951c5c19e$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $cc64e8f951c5c19e$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $cc64e8f951c5c19e$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $cc64e8f951c5c19e$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $cc64e8f951c5c19e$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$cc64e8f951c5c19e$var$mutableInstrumentations, $cc64e8f951c5c19e$var$readonlyInstrumentations, $cc64e8f951c5c19e$var$shallowInstrumentations, $cc64e8f951c5c19e$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $cc64e8f951c5c19e$var$createInstrumentations();
function $cc64e8f951c5c19e$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $cc64e8f951c5c19e$var$shallowReadonlyInstrumentations : $cc64e8f951c5c19e$var$shallowInstrumentations : isReadonly ? $cc64e8f951c5c19e$var$readonlyInstrumentations : $cc64e8f951c5c19e$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($cc64e8f951c5c19e$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $cc64e8f951c5c19e$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $cc64e8f951c5c19e$var$createInstrumentationGetter(false, false)
};
var $cc64e8f951c5c19e$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $cc64e8f951c5c19e$var$createInstrumentationGetter(true, false)
};
function $cc64e8f951c5c19e$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $cc64e8f951c5c19e$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $cc64e8f951c5c19e$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $cc64e8f951c5c19e$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $cc64e8f951c5c19e$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $cc64e8f951c5c19e$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $cc64e8f951c5c19e$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $cc64e8f951c5c19e$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $cc64e8f951c5c19e$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $cc64e8f951c5c19e$var$targetTypeMap($cc64e8f951c5c19e$var$toRawType(value));
}
function $cc64e8f951c5c19e$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $cc64e8f951c5c19e$var$createReactiveObject(target, false, $cc64e8f951c5c19e$var$mutableHandlers, $cc64e8f951c5c19e$var$mutableCollectionHandlers, $cc64e8f951c5c19e$var$reactiveMap);
}
function $cc64e8f951c5c19e$var$readonly(target) {
    return $cc64e8f951c5c19e$var$createReactiveObject(target, true, $cc64e8f951c5c19e$var$readonlyHandlers, $cc64e8f951c5c19e$var$readonlyCollectionHandlers, $cc64e8f951c5c19e$var$readonlyMap);
}
function $cc64e8f951c5c19e$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$cc64e8f951c5c19e$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $cc64e8f951c5c19e$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $cc64e8f951c5c19e$var$toRaw(observed) {
    return observed && $cc64e8f951c5c19e$var$toRaw(observed["__v_raw"]) || observed;
}
function $cc64e8f951c5c19e$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$cc64e8f951c5c19e$var$magic("nextTick", ()=>$cc64e8f951c5c19e$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$cc64e8f951c5c19e$var$magic("dispatch", (el)=>$cc64e8f951c5c19e$var$dispatch.bind($cc64e8f951c5c19e$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$cc64e8f951c5c19e$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $cc64e8f951c5c19e$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$cc64e8f951c5c19e$var$magic("store", $cc64e8f951c5c19e$var$getStores);
// packages/alpinejs/src/magics/$data.js
$cc64e8f951c5c19e$var$magic("data", (el)=>$cc64e8f951c5c19e$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$cc64e8f951c5c19e$var$magic("root", (el)=>$cc64e8f951c5c19e$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$cc64e8f951c5c19e$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $cc64e8f951c5c19e$var$mergeProxies($cc64e8f951c5c19e$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $cc64e8f951c5c19e$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $cc64e8f951c5c19e$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $cc64e8f951c5c19e$var$globalIdMemo = {};
function $cc64e8f951c5c19e$var$findAndIncrementId(name) {
    if (!$cc64e8f951c5c19e$var$globalIdMemo[name]) $cc64e8f951c5c19e$var$globalIdMemo[name] = 0;
    return ++$cc64e8f951c5c19e$var$globalIdMemo[name];
}
function $cc64e8f951c5c19e$var$closestIdRoot(el, name) {
    return $cc64e8f951c5c19e$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $cc64e8f951c5c19e$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $cc64e8f951c5c19e$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$cc64e8f951c5c19e$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $cc64e8f951c5c19e$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $cc64e8f951c5c19e$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $cc64e8f951c5c19e$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$cc64e8f951c5c19e$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $cc64e8f951c5c19e$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$cc64e8f951c5c19e$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$cc64e8f951c5c19e$var$warnMissingPluginMagic("Focus", "focus", "focus");
$cc64e8f951c5c19e$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $cc64e8f951c5c19e$var$warnMissingPluginMagic(name, magicName, slug) {
    $cc64e8f951c5c19e$var$magic(magicName, (el)=>$cc64e8f951c5c19e$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$cc64e8f951c5c19e$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $cc64e8f951c5c19e$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$cc64e8f951c5c19e$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $cc64e8f951c5c19e$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $cc64e8f951c5c19e$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $cc64e8f951c5c19e$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $cc64e8f951c5c19e$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $cc64e8f951c5c19e$var$skipDuringClone(()=>{
            $cc64e8f951c5c19e$var$initTree(clone2);
            clone2._x_ignore = true;
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $cc64e8f951c5c19e$var$getTarget(expression);
        $cc64e8f951c5c19e$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>clone2.remove());
});
var $cc64e8f951c5c19e$var$teleportContainerDuringClone = document.createElement("div");
function $cc64e8f951c5c19e$var$getTarget(expression) {
    let target = $cc64e8f951c5c19e$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $cc64e8f951c5c19e$var$teleportContainerDuringClone;
    })();
    if (!target) $cc64e8f951c5c19e$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $cc64e8f951c5c19e$var$handler = ()=>{};
$cc64e8f951c5c19e$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$cc64e8f951c5c19e$var$directive("ignore", $cc64e8f951c5c19e$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$cc64e8f951c5c19e$var$directive("effect", $cc64e8f951c5c19e$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($cc64e8f951c5c19e$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $cc64e8f951c5c19e$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $cc64e8f951c5c19e$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $cc64e8f951c5c19e$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $cc64e8f951c5c19e$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $cc64e8f951c5c19e$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $cc64e8f951c5c19e$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $cc64e8f951c5c19e$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    handler4 = wrapHandler(handler4, (next, e)=>{
        if ($cc64e8f951c5c19e$var$isKeyEvent(event)) {
            if ($cc64e8f951c5c19e$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        }
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $cc64e8f951c5c19e$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $cc64e8f951c5c19e$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $cc64e8f951c5c19e$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $cc64e8f951c5c19e$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $cc64e8f951c5c19e$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $cc64e8f951c5c19e$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $cc64e8f951c5c19e$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $cc64e8f951c5c19e$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $cc64e8f951c5c19e$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($cc64e8f951c5c19e$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $cc64e8f951c5c19e$var$keyToModifiers(key) {
    if (!key) return [];
    key = $cc64e8f951c5c19e$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$cc64e8f951c5c19e$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $cc64e8f951c5c19e$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $cc64e8f951c5c19e$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $cc64e8f951c5c19e$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $cc64e8f951c5c19e$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($cc64e8f951c5c19e$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $cc64e8f951c5c19e$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $cc64e8f951c5c19e$var$isCloning ? ()=>{} : $cc64e8f951c5c19e$var$on(el, event, modifiers, (e)=>{
        setValue($cc64e8f951c5c19e$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($cc64e8f951c5c19e$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $cc64e8f951c5c19e$var$on(el.form, "reset", [], (e)=>{
            $cc64e8f951c5c19e$var$nextTick(()=>el._x_model && el._x_model.set($cc64e8f951c5c19e$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $cc64e8f951c5c19e$var$mutateDom(()=>$cc64e8f951c5c19e$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $cc64e8f951c5c19e$var$getInputValue(el, modifiers, event, currentValue) {
    return $cc64e8f951c5c19e$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $cc64e8f951c5c19e$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $cc64e8f951c5c19e$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$cc64e8f951c5c19e$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $cc64e8f951c5c19e$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $cc64e8f951c5c19e$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if (el.type === "radio") {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $cc64e8f951c5c19e$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $cc64e8f951c5c19e$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $cc64e8f951c5c19e$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $cc64e8f951c5c19e$var$isNumeric2(number) ? number : rawValue;
}
function $cc64e8f951c5c19e$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $cc64e8f951c5c19e$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $cc64e8f951c5c19e$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$cc64e8f951c5c19e$var$directive("cloak", (el)=>queueMicrotask(()=>$cc64e8f951c5c19e$var$mutateDom(()=>el.removeAttribute($cc64e8f951c5c19e$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$cc64e8f951c5c19e$var$addInitSelector(()=>`[${$cc64e8f951c5c19e$var$prefix("init")}]`);
$cc64e8f951c5c19e$var$directive("init", $cc64e8f951c5c19e$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$cc64e8f951c5c19e$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $cc64e8f951c5c19e$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$cc64e8f951c5c19e$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $cc64e8f951c5c19e$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $cc64e8f951c5c19e$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$cc64e8f951c5c19e$var$mapAttributes($cc64e8f951c5c19e$var$startingWith(":", $cc64e8f951c5c19e$var$into($cc64e8f951c5c19e$var$prefix("bind:"))));
var $cc64e8f951c5c19e$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $cc64e8f951c5c19e$var$injectBindingProviders(bindingProviders);
        let getBindings = $cc64e8f951c5c19e$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $cc64e8f951c5c19e$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $cc64e8f951c5c19e$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $cc64e8f951c5c19e$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $cc64e8f951c5c19e$var$mutateDom(()=>$cc64e8f951c5c19e$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$cc64e8f951c5c19e$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$cc64e8f951c5c19e$var$directive("bind", $cc64e8f951c5c19e$var$handler2);
function $cc64e8f951c5c19e$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$cc64e8f951c5c19e$var$addRootSelector(()=>`[${$cc64e8f951c5c19e$var$prefix("data")}]`);
$cc64e8f951c5c19e$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($cc64e8f951c5c19e$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $cc64e8f951c5c19e$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $cc64e8f951c5c19e$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $cc64e8f951c5c19e$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $cc64e8f951c5c19e$var$injectMagics(data2, el);
    let reactiveData = $cc64e8f951c5c19e$var$reactive(data2);
    $cc64e8f951c5c19e$var$initInterceptors(reactiveData);
    let undo = $cc64e8f951c5c19e$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $cc64e8f951c5c19e$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $cc64e8f951c5c19e$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$cc64e8f951c5c19e$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $cc64e8f951c5c19e$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$cc64e8f951c5c19e$var$isCloning) return false;
    if ($cc64e8f951c5c19e$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$cc64e8f951c5c19e$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $cc64e8f951c5c19e$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $cc64e8f951c5c19e$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $cc64e8f951c5c19e$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $cc64e8f951c5c19e$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$cc64e8f951c5c19e$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $cc64e8f951c5c19e$var$parseForExpression(expression);
    let evaluateItems = $cc64e8f951c5c19e$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $cc64e8f951c5c19e$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$cc64e8f951c5c19e$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $cc64e8f951c5c19e$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($cc64e8f951c5c19e$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $cc64e8f951c5c19e$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $cc64e8f951c5c19e$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $cc64e8f951c5c19e$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $cc64e8f951c5c19e$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($cc64e8f951c5c19e$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $cc64e8f951c5c19e$var$mutateDom(()=>{
                if (!elForSpot) $cc64e8f951c5c19e$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $cc64e8f951c5c19e$var$reactive(scope2);
            $cc64e8f951c5c19e$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $cc64e8f951c5c19e$var$mutateDom(()=>{
                lastEl.after(clone2);
                $cc64e8f951c5c19e$var$skipDuringClone(()=>$cc64e8f951c5c19e$var$initTree(clone2))();
            });
            if (typeof key === "object") $cc64e8f951c5c19e$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $cc64e8f951c5c19e$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $cc64e8f951c5c19e$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $cc64e8f951c5c19e$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $cc64e8f951c5c19e$var$handler3() {}
$cc64e8f951c5c19e$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $cc64e8f951c5c19e$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$cc64e8f951c5c19e$var$directive("ref", $cc64e8f951c5c19e$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$cc64e8f951c5c19e$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $cc64e8f951c5c19e$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $cc64e8f951c5c19e$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $cc64e8f951c5c19e$var$addScopeToNode(clone2, {}, el);
        $cc64e8f951c5c19e$var$mutateDom(()=>{
            el.after(clone2);
            $cc64e8f951c5c19e$var$skipDuringClone(()=>$cc64e8f951c5c19e$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $cc64e8f951c5c19e$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($cc64e8f951c5c19e$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$cc64e8f951c5c19e$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$cc64e8f951c5c19e$var$setIdRoot(el, name));
});
$cc64e8f951c5c19e$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$cc64e8f951c5c19e$var$mapAttributes($cc64e8f951c5c19e$var$startingWith("@", $cc64e8f951c5c19e$var$into($cc64e8f951c5c19e$var$prefix("on:"))));
$cc64e8f951c5c19e$var$directive("on", $cc64e8f951c5c19e$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $cc64e8f951c5c19e$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $cc64e8f951c5c19e$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$cc64e8f951c5c19e$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$cc64e8f951c5c19e$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$cc64e8f951c5c19e$var$warnMissingPluginDirective("Focus", "trap", "focus");
$cc64e8f951c5c19e$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $cc64e8f951c5c19e$var$warnMissingPluginDirective(name, directiveName, slug) {
    $cc64e8f951c5c19e$var$directive(directiveName, (el)=>$cc64e8f951c5c19e$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$cc64e8f951c5c19e$var$alpine_default.setEvaluator($cc64e8f951c5c19e$var$normalEvaluator);
$cc64e8f951c5c19e$var$alpine_default.setReactivityEngine({
    reactive: $cc64e8f951c5c19e$var$reactive2,
    effect: $cc64e8f951c5c19e$var$effect2,
    release: $cc64e8f951c5c19e$var$stop,
    raw: $cc64e8f951c5c19e$var$toRaw
});
var $cc64e8f951c5c19e$export$b7ee041e4ad2afec = $cc64e8f951c5c19e$var$alpine_default;
// packages/alpinejs/builds/module.js
var $cc64e8f951c5c19e$export$2e2bcd8739ae039 = $cc64e8f951c5c19e$export$b7ee041e4ad2afec;


// packages/intersect/src/index.js
function $9aeea8615f40f0fb$export$1f4807a235930d45(Alpine) {
    Alpine.directive("intersect", Alpine.skipDuringClone((el, { value: value, expression: expression, modifiers: modifiers }, { evaluateLater: evaluateLater, cleanup: cleanup })=>{
        let evaluate = evaluateLater(expression);
        let options = {
            rootMargin: $9aeea8615f40f0fb$var$getRootMargin(modifiers),
            threshold: $9aeea8615f40f0fb$var$getThreshold(modifiers)
        };
        let observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting === (value === "leave")) return;
                evaluate();
                modifiers.includes("once") && observer.disconnect();
            });
        }, options);
        observer.observe(el);
        cleanup(()=>{
            observer.disconnect();
        });
    }));
}
function $9aeea8615f40f0fb$var$getThreshold(modifiers) {
    if (modifiers.includes("full")) return 0.99;
    if (modifiers.includes("half")) return 0.5;
    if (!modifiers.includes("threshold")) return 0;
    let threshold = modifiers[modifiers.indexOf("threshold") + 1];
    if (threshold === "100") return 1;
    if (threshold === "0") return 0;
    return Number(`.${threshold}`);
}
function $9aeea8615f40f0fb$var$getLengthValue(rawValue) {
    let match = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
    return match ? match[1] + (match[2] || "px") : void 0;
}
function $9aeea8615f40f0fb$var$getRootMargin(modifiers) {
    const key = "margin";
    const fallback = "0px 0px 0px 0px";
    const index = modifiers.indexOf(key);
    if (index === -1) return fallback;
    let values = [];
    for(let i = 1; i < 5; i++)values.push($9aeea8615f40f0fb$var$getLengthValue(modifiers[index + i] || ""));
    values = values.filter((v)=>v !== void 0);
    return values.length ? values.join(" ").trim() : fallback;
}
// packages/intersect/builds/module.js
var $9aeea8615f40f0fb$export$2e2bcd8739ae039 = $9aeea8615f40f0fb$export$1f4807a235930d45;


function $0dfdb7c551d2baa4$export$ef1639a4b889352d(fn) {
    if (typeof fn === "string") {
        console.warn("Tohle nen\xed jQuery, pro hled\xe1n\xed element\u016F na str\xe1nce dle selektoru pou\u017Eij $$!");
        return;
    }
    if (document.readyState === "complete") fn();
    else document.addEventListener("DOMContentLoaded", fn);
}
function $0dfdb7c551d2baa4$export$71aa6c912b956294(selector, parent) {
    if (!parent) parent = document;
    return parent.querySelector(selector);
}
const $0dfdb7c551d2baa4$export$3d8c2f653ac9d0b9 = $0dfdb7c551d2baa4$export$ef1639a4b889352d;
const $0dfdb7c551d2baa4$export$fe324b23443c13e2 = $0dfdb7c551d2baa4$export$71aa6c912b956294;


function $66636ab2821c0fd2$export$184d891e7bcc1821(wrap) {
    let body = (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="body"]', wrap);
    let bg = (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="bg"]', wrap);
    if (body && bg) $66636ab2821c0fd2$var$startAnimation(body, bg);
}
function $66636ab2821c0fd2$var$startAnimation(body, bg) {
    body.classList.add("state-running");
    bg.classList.add("state-running");
    setTimeout(()=>{
        body.classList.add("state-animated");
        bg.classList.add("state-animated");
    }, 10);
    setTimeout(()=>{
        bg.classList.add("state-step-1");
    }, 100);
    setTimeout(()=>{
        body.classList.add("state-step-1");
    }, 600);
    setTimeout(()=>{
        body.classList.add("state-step-2");
    }, 2100);
    setTimeout(()=>{
        body.classList.add("state-step-3");
    }, 3100);
    setTimeout(()=>{
        body.classList.add("state-step-4");
    }, 4000);
    setTimeout(()=>{
        body.classList.remove("state-animated");
    }, 5000);
}




let $c2b70431fb0f79fc$var$interval;
let $c2b70431fb0f79fc$var$previousVisibility = "";
let $c2b70431fb0f79fc$var$marqueeWrap;
let $c2b70431fb0f79fc$var$animated = false;
let $c2b70431fb0f79fc$var$progress = 0;
let $c2b70431fb0f79fc$var$speed = 0.075;
function $c2b70431fb0f79fc$export$e15b70a9500e668e(wrap, speedOfScroll = 0.075) {
    if ($c2b70431fb0f79fc$var$marqueeWrap) throw new Error("Right now, there can be one marquee per page.");
    $c2b70431fb0f79fc$var$marqueeWrap = wrap;
    $c2b70431fb0f79fc$var$speed = speedOfScroll;
    // Replicate text 3x
    let text = (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="text"]', wrap);
    if (!text) return;
    let clone1 = text?.cloneNode(true);
    let clone2 = text?.cloneNode(true);
    text.parentNode.appendChild(clone1);
    text.parentNode.appendChild(clone2);
    requestAnimationFrame(()=>{
        $c2b70431fb0f79fc$var$animated = true;
        $c2b70431fb0f79fc$var$startAnimation();
        $c2b70431fb0f79fc$var$animationStep();
        $c2b70431fb0f79fc$var$updateHtml();
    });
    if (typeof document !== "undefined") document.addEventListener("visibilitychange", $c2b70431fb0f79fc$var$visibilityHandler);
}
function $c2b70431fb0f79fc$var$visibilityHandler() {
    if (document.visibilityState === "hidden") $c2b70431fb0f79fc$var$previousVisibility = "hidden";
    else if ($c2b70431fb0f79fc$var$previousVisibility === "hidden") {
        $c2b70431fb0f79fc$var$startAnimation();
        $c2b70431fb0f79fc$var$previousVisibility = "";
        $c2b70431fb0f79fc$var$animated = false;
        $c2b70431fb0f79fc$var$updateHtml();
        requestAnimationFrame(()=>{
            $c2b70431fb0f79fc$var$progress = 0;
            $c2b70431fb0f79fc$var$updateHtml();
            requestAnimationFrame(()=>{
                $c2b70431fb0f79fc$var$animationStep();
            });
        });
    }
}
function $c2b70431fb0f79fc$var$startAnimation() {
    if ($c2b70431fb0f79fc$var$interval) {
        clearInterval($c2b70431fb0f79fc$var$interval);
        $c2b70431fb0f79fc$var$interval = null;
    }
    $c2b70431fb0f79fc$var$interval = setInterval(()=>{
        $c2b70431fb0f79fc$var$animationStep();
    }, 999);
}
function $c2b70431fb0f79fc$var$animationStep() {
    if ($c2b70431fb0f79fc$var$progress < 1.1) {
        $c2b70431fb0f79fc$var$progress += $c2b70431fb0f79fc$var$speed;
        $c2b70431fb0f79fc$var$animated = true;
        $c2b70431fb0f79fc$var$updateHtml();
    } else {
        $c2b70431fb0f79fc$var$animated = false;
        $c2b70431fb0f79fc$var$updateHtml();
        requestAnimationFrame(()=>{
            $c2b70431fb0f79fc$var$progress -= 1;
            $c2b70431fb0f79fc$var$updateHtml();
            requestAnimationFrame(()=>{
                $c2b70431fb0f79fc$var$animationStep();
                $c2b70431fb0f79fc$var$updateHtml();
            });
        });
    }
    $c2b70431fb0f79fc$var$progress = Math.round($c2b70431fb0f79fc$var$progress * 100) / 100;
}
function $c2b70431fb0f79fc$var$updateHtml() {
    $c2b70431fb0f79fc$var$marqueeWrap.querySelector('[data-part="mover"]').classList.toggle("marquee__mover--animated", $c2b70431fb0f79fc$var$animated);
    $c2b70431fb0f79fc$var$marqueeWrap.style.setProperty("--progress", $c2b70431fb0f79fc$var$progress + "");
}


var $33b0941447f8d100$exports = {};
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $33b0941447f8d100$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$33b0941447f8d100$var$debounce.debounce = $33b0941447f8d100$var$debounce;
$33b0941447f8d100$exports = $33b0941447f8d100$var$debounce;


let $3e34147788aac7fc$var$observerAvailable = typeof window !== "undefined" && typeof window?.IntersectionObserver !== "undefined";
let $3e34147788aac7fc$var$observer = null;
let $3e34147788aac7fc$var$violetBackgrounds = new Set();
let $3e34147788aac7fc$var$normalBackgrounds = new Set();
let $3e34147788aac7fc$var$lock = false;
function $3e34147788aac7fc$var$createIntersectionObserver() {
    if (!$3e34147788aac7fc$var$observerAvailable) return;
    if ($3e34147788aac7fc$var$observer) {
        $3e34147788aac7fc$var$observer.disconnect();
        $3e34147788aac7fc$var$observer = null;
    }
    let navbar = document.querySelector("#main-menu-observed-part");
    if (!navbar) {
        console.error("No #main-menu-observed-part on page!");
        return;
    }
    let topMargin = -1 * navbar.offsetTop + "px";
    let bottomMargin = -1 * (window.innerHeight - navbar.offsetTop - navbar.clientHeight) + "px";
    let observerRootMargin = topMargin + " 0px " + bottomMargin + " 0px";
    $3e34147788aac7fc$var$observer = new IntersectionObserver($3e34147788aac7fc$var$observerTrigger, {
        rootMargin: observerRootMargin
    });
    $3e34147788aac7fc$var$violetBackgrounds.forEach((el)=>$3e34147788aac7fc$var$observer?.observe(el));
    $3e34147788aac7fc$var$normalBackgrounds.forEach((el)=>$3e34147788aac7fc$var$observer?.observe(el));
}
function $3e34147788aac7fc$var$observerTrigger(entries) {
    entries.forEach((e)=>{
        if (!e.isIntersecting) {
            if ($3e34147788aac7fc$var$lock) return;
            document.body.classList.remove("body-white-background");
            document.body.classList.remove("body-violet-background");
        } else {
            if ($3e34147788aac7fc$var$violetBackgrounds.has(e.target)) document.body.classList.add("body-violet-background");
            else document.body.classList.add("body-white-background");
            $3e34147788aac7fc$var$lock = true;
            setTimeout(()=>{
                $3e34147788aac7fc$var$lock = false;
            }, 50);
        }
    });
}
function $3e34147788aac7fc$export$989c30d48b8bcad8(element, isVioletBackground = false) {
    if ($3e34147788aac7fc$var$observerAvailable && !$3e34147788aac7fc$var$observer) $3e34147788aac7fc$var$createIntersectionObserver();
    if (!$3e34147788aac7fc$var$observerAvailable || !$3e34147788aac7fc$var$observer) return;
    $3e34147788aac7fc$var$observer.observe(element);
    if (isVioletBackground) $3e34147788aac7fc$var$violetBackgrounds.add(element);
    else $3e34147788aac7fc$var$normalBackgrounds.add(element);
}
function $3e34147788aac7fc$export$11dd745f404f52e(element) {
    if (!$3e34147788aac7fc$var$observerAvailable || !$3e34147788aac7fc$var$observer) return;
    $3e34147788aac7fc$var$observer?.unobserve(element);
    if ($3e34147788aac7fc$var$violetBackgrounds.has(element)) $3e34147788aac7fc$var$violetBackgrounds.delete(element);
    if ($3e34147788aac7fc$var$normalBackgrounds.has(element)) $3e34147788aac7fc$var$normalBackgrounds.delete(element);
}
if (typeof window !== "undefined") window.addEventListener("resize", (0, (/*@__PURE__*/$parcel$interopDefault($33b0941447f8d100$exports)))($3e34147788aac7fc$var$createIntersectionObserver, 150));



/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset).
 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function}  A new, throttled, function.
 */ function $f4f10b89c7904ba1$export$de363e709c412c8a(delay, noTrailing, callback, debounceMode) {
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false; // Keep track of the last time `callback` was executed.
    var lastExec = 0; // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    } // Function to cancel next exec
    function cancel() {
        clearExistingTimeout();
        cancelled = true;
    } // `noTrailing` defaults to falsy.
    if (typeof noTrailing !== "boolean") {
        debounceMode = callback;
        callback = noTrailing;
        noTrailing = undefined;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
         // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */ exec();
        else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel; // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @returns {Function} A new, debounced function.
 */ function $f4f10b89c7904ba1$export$61fc7d43ac8f84b0(delay, atBegin, callback) {
    return callback === undefined ? $f4f10b89c7904ba1$export$de363e709c412c8a(delay, atBegin, false) : $f4f10b89c7904ba1$export$de363e709c412c8a(delay, callback, atBegin !== false);
}


function $b3c89e5b3e7bf52b$export$a62c8aec0a4ae36e(wrap) {
    let paneWrap = (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="pane-wrap"]', wrap);
    if (!paneWrap) return;
    let currentPane = 0;
    window.addEventListener("scroll", (0, $f4f10b89c7904ba1$export$de363e709c412c8a)(100, ()=>{
        let currentRect = paneWrap.getBoundingClientRect();
        let objectTop = currentRect.top;
        let objectPos = currentRect.top + currentRect.height / 2;
        let midOfScreen = window.innerHeight / 2;
        if (objectPos < midOfScreen || objectTop < 80) {
            if (currentPane !== 1) {
                $b3c89e5b3e7bf52b$var$changePane(1);
                currentPane = 1;
            }
        } else if (currentPane !== 0) {
            $b3c89e5b3e7bf52b$var$changePane(0);
            currentPane = 0;
        }
    }));
}
function $b3c89e5b3e7bf52b$var$changePane(index) {
    let event = new CustomEvent("homeneatlycapture", {
        detail: index
    });
    window.dispatchEvent(event);
}


var $22863f89e813ffba$exports = {};
$22863f89e813ffba$exports = $22863f89e813ffba$var$clamp;
function $22863f89e813ffba$var$clamp(value, min, max) {
    return min < max ? value < min ? min : value > max ? max : value : value < max ? max : value > min ? min : value;
}


class $c7dfd6af108b7a5f$export$e4569f41d3277b00 {
    /**
	 * @param thePath The path element that is used to animate target
	 * @param svg The SVG that contains the Path
	 * @param cssTarget The element that receives X and Y coordinates as CSS properties
	 * @param scrollElement The element that is measured for scroll position.
	 *    Target starts its motion when middle (or settable YPosOnViewportToTarget) of screen reaches top of this element
	 *    and ends its motion when middle reaches bottom of this element.
	 */ constructor(thePath, svg, cssTarget, scrollElement = null){
        this.thePath = thePath;
        this.svg = svg;
        this.cssTarget = cssTarget;
        this.scrollElement = scrollElement;
        this.currentProgress = 0;
        this.nextTickPlanned = false;
        this.cssPropertyXName = "--x";
        this.cssPropertyYName = "--y";
        this.maxSpeed = 0.01;
        this.speed = 0.06;
        this.yPosOnViewportToTarget = 0.5;
        this.translateX = 0;
        this.translateY = 0;
        this.callback = null;
        if (!this.scrollElement) this.scrollElement = this.cssTarget;
    }
    set isActiveFunction(fn) {
        this._isActiveFunction = fn;
    }
    setCssPropertyNames(x = "--x", y = "--y") {
        this.cssPropertyXName = x;
        this.cssPropertyYName = y;
    }
    setSpeed(speed, maxSpeed) {
        this.maxSpeed = maxSpeed;
        this.speed = speed;
    }
    setTranslate(x, y) {
        this.translateX = x;
        this.translateY = y;
    }
    setYPosOnViewportToTarget(pos) {
        this.yPosOnViewportToTarget = pos;
    }
    setCallback(fn) {
        this.callback = fn;
    }
    init() {
        if (this.scrollListener) throw new Error("init() was already called on something!");
        this.scrollListener = ()=>{
            this.animationStep(false);
        };
        window.addEventListener("scroll", this.scrollListener);
        window.addEventListener("resize", this.scrollListener);
        this.animationStep(true);
    }
    destroy() {
        if (this.scrollListener) {
            window.removeEventListener("scroll", this.scrollListener);
            window.removeEventListener("resize", this.scrollListener);
            this.scrollListener = undefined;
        }
    }
    calcPosFromProgress(progress) {
        progress = (0, (/*@__PURE__*/$parcel$interopDefault($22863f89e813ffba$exports)))(progress, 0, 1);
        let l = this.thePath.getTotalLength();
        let svgBox = this.svg.viewBox;
        let pos = this.thePath.getPointAtLength(l * progress);
        return {
            x: (pos.x + this.translateX) / svgBox.baseVal.width,
            y: (pos.y + this.translateY) / svgBox.baseVal.height
        };
    }
    calcProgressFromCurrentScroll() {
        let rect = this.scrollElement.getBoundingClientRect();
        let topPos = rect.top;
        let bottomPos = rect.top + rect.height;
        let midScreenPos = window.innerHeight * this.yPosOnViewportToTarget;
        let progress = (0, (/*@__PURE__*/$parcel$interopDefault($22863f89e813ffba$exports)))((midScreenPos - topPos) / (bottomPos - topPos), 0, 1);
        return progress;
    }
    animationStep(instant = false) {
        if (this._isActiveFunction && !this._isActiveFunction()) return;
        let progress = this.calcProgressFromCurrentScroll();
        if (instant) this.currentProgress = progress;
        else if (Math.abs(this.currentProgress - progress) < 0.001) this.currentProgress = progress;
        else {
            let step = (progress - this.currentProgress) * this.speed;
            step = (0, (/*@__PURE__*/$parcel$interopDefault($22863f89e813ffba$exports)))(step, -1 * this.maxSpeed, this.maxSpeed);
            this.currentProgress += step;
            this.planNextTick();
        }
        let coords = this.calcPosFromProgress(this.currentProgress);
        this.applyProgress(coords.x, coords.y);
        if (this.callback) this.callback(this.currentProgress, coords.x, coords.y);
    }
    planNextTick() {
        if (!this.nextTickPlanned) {
            this.nextTickPlanned = true;
            requestAnimationFrame(()=>{
                this.nextTickPlanned = false;
                this.animationStep();
            });
        }
    }
    applyProgress(xCoord, yCoord) {
        this.cssTarget.style.setProperty(this.cssPropertyXName, xCoord + "");
        this.cssTarget.style.setProperty(this.cssPropertyYName, yCoord + "");
    }
}



// Keep in sync with scss/vars/breakpoints.scss !!!
// Keep in sync with hardcoded values in:
//    - home-brm-platform.html
//    - zug.html
const $b4b82bc54238a047$export$e6d49f2439d5ceea = {
    XS: 580,
    SM: 980,
    MD: 1220,
    LG: 1600
};



function $a4fb6e4418ec70b2$export$7a78f9e6092fd349(wrap) {
    let effectPath = (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="path"]');
    let effectSvg = (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="svg"]');
    let effectBody = (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="effect-body"]');
    let effectHeight = (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="height"]');
    if (!effectBody || !effectHeight || !effectPath || !effectSvg) return;
    let theEffect = new (0, $c7dfd6af108b7a5f$export$e4569f41d3277b00)(effectPath, effectSvg, effectBody, effectHeight);
    theEffect.isActiveFunction = ()=>{
        return window.innerWidth >= (0, $b4b82bc54238a047$export$e6d49f2439d5ceea).XS;
    };
    theEffect.init();
    (0, $3e34147788aac7fc$export$989c30d48b8bcad8)(wrap, true);
}




function $db8fc88432e9d8af$export$543ec7a4a69e375a(wrap) {
    (0, $3e34147788aac7fc$export$989c30d48b8bcad8)(wrap);
    (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="arrow"]', wrap)?.addEventListener("click", ()=>{
        $db8fc88432e9d8af$var$scrollDown(wrap);
    });
}
function $db8fc88432e9d8af$var$scrollDown(wrap) {
    let bottomPart = (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="bottom"]', wrap);
    if (bottomPart) bottomPart.scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
}




function $2ff7e82575b94e4c$export$df5af4369e5bf252(wrap) {
    window.addEventListener("solutioninsightsgoto", (e)=>{
        let pane = e.detail;
        $2ff7e82575b94e4c$var$scrollToContentPart(wrap, pane);
    });
}
function $2ff7e82575b94e4c$var$scrollToContentPart(wrap, paneIndex) {
    let target = (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="part' + paneIndex + '"]', wrap);
    if (target) {
        let top = target.getBoundingClientRect().top + window.scrollY;
        let offset = window.innerWidth < (0, $b4b82bc54238a047$export$e6d49f2439d5ceea).SM ? 80 : 140; // for navbar and nice top margin
        window.scrollTo({
            behavior: "smooth",
            top: top - offset
        });
    }
}



function $cd5da2fb3520efb4$export$2a6f22bf2145b965(wrap) {
    window.addEventListener("solutionoptions", (e)=>{
        setTimeout(()=>{
            $cd5da2fb3520efb4$var$fixScrollToItem(wrap, e.detail);
        }, 100);
    });
}
function $cd5da2fb3520efb4$var$fixScrollToItem(wrap, index) {
    let el = (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="item' + index + '"]', wrap);
    if (!el) return;
    let rect = el.getBoundingClientRect();
    if (rect.top < 0) window.scrollBy({
        behavior: "smooth",
        top: rect.top - 70 // 70 px as approx. height of navbar
    });
}





function $39ece5819af7acfa$export$159bc2be09fff49e(wrap) {
    let thePath = (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="svgPath"]', wrap);
    let theSvg = (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="svg"]', wrap);
    let mainContainer = (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="main"]', wrap);
    if (!thePath || !theSvg || !mainContainer) return;
    let scrollEffect = new (0, $c7dfd6af108b7a5f$export$e4569f41d3277b00)(thePath, theSvg, mainContainer);
    scrollEffect.setTranslate(52, 120);
    scrollEffect.setSpeed(0.04, 0.007);
    scrollEffect.setCallback((progress, _x, _y)=>{
        let whichStep = $39ece5819af7acfa$var$stepHighlighter(progress);
        window.dispatchEvent(new CustomEvent("easytodeploystep", {
            detail: whichStep
        }));
    });
    scrollEffect.isActiveFunction = ()=>{
        return window.innerWidth >= (0, $b4b82bc54238a047$export$e6d49f2439d5ceea).SM;
    };
    scrollEffect.init();
}
const $39ece5819af7acfa$var$importantPointsOnPath = [
    0.25,
    0.545,
    0.845
];
function $39ece5819af7acfa$var$stepHighlighter(progress) {
    if (progress < $39ece5819af7acfa$var$importantPointsOnPath[0]) return 1;
    else if (progress < $39ece5819af7acfa$var$importantPointsOnPath[1]) return 2;
    else if (progress < $39ece5819af7acfa$var$importantPointsOnPath[2]) return 3;
    else return 4;
}




function $a9543e944f7e4048$export$4bda925ccc2b533a(wrap) {
    wrap.addEventListener("faqchanged", (e)=>{
        if (e.detail !== null && window.innerWidth < (0, $b4b82bc54238a047$export$e6d49f2439d5ceea).SM) // On mobiles, we need to rescroll to top of the newly expanded question
        // https://jira.wdf.cz/browse/XPLOR-31#comment-49511
        setTimeout(()=>{
            $a9543e944f7e4048$var$fixScrollToQuestion(wrap, e.detail);
        }, 300);
    });
}
function $a9543e944f7e4048$var$fixScrollToQuestion(wrap, index) {
    let el = (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="item' + index + '"]', wrap);
    if (!el) return;
    let rect = el.getBoundingClientRect();
    if (rect.top < 0) window.scrollBy({
        behavior: "smooth",
        top: rect.top - 85 // 85 px as height of navbar
    });
}



function $fa5ad37614750c0e$export$b3ec60d973020449(input) {
    input.addEventListener("invalid", ()=>$fa5ad37614750c0e$var$touchControl(input));
    input.addEventListener("blur", ()=>$fa5ad37614750c0e$var$touchControl(input));
}
function $fa5ad37614750c0e$var$touchControl(input) {
    if (input.type === "checkbox") input.classList.add("g-checkbox--touched");
    else input.classList.add("g-input--touched");
}


function $7e5bb862242eb744$export$d5bd5b80f649d6c(wrap) {
    (0, $3e34147788aac7fc$export$989c30d48b8bcad8)(wrap);
    wrap.querySelectorAll("input").forEach((i)=>(0, $fa5ad37614750c0e$export$b3ec60d973020449)(i));
}
function $7e5bb862242eb744$export$f0b94daf0c371d49(form, canBeSentHandler, startSendingHandler, markAsSentHandler, resetHandler) {
    if (!canBeSentHandler()) {
        resetHandler();
        return;
    }
    let valid = form.checkValidity();
    if (!valid) {
        form.reportValidity();
        return;
    }
    startSendingHandler();
    setTimeout(()=>{
        markAsSentHandler();
        setTimeout(()=>{
            resetHandler();
        }, 2000);
    }, 1500);
}





function $b0fd8fbdab86d582$export$c9d1c5c6e981c59a(wrap) {
    let theEffect = new (0, $c7dfd6af108b7a5f$export$e4569f41d3277b00)((0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="path"]', wrap), (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="svg"]', wrap), (0, $0dfdb7c551d2baa4$export$fe324b23443c13e2)('[data-part="deco"]', wrap));
    theEffect.isActiveFunction = ()=>{
        return window.innerWidth >= (0, $b4b82bc54238a047$export$e6d49f2439d5ceea).SM;
    };
    theEffect.setYPosOnViewportToTarget(0.4);
    theEffect.init();
}



class $3fe66f928c64cef1$export$510e4918aa4d8ee5 {
    constructor(){
        this.homeHero = (0, $66636ab2821c0fd2$export$184d891e7bcc1821);
        this.marquee = (0, $c2b70431fb0f79fc$export$e15b70a9500e668e);
        this.addThingWithWhiteBackground = (0, $3e34147788aac7fc$export$989c30d48b8bcad8);
        this.removeThingWithWhitebackground = (0, $3e34147788aac7fc$export$11dd745f404f52e);
        this.homeNeatlyCapture = (0, $b3c89e5b3e7bf52b$export$a62c8aec0a4ae36e);
        this.homeVioletBlock = (0, $a4fb6e4418ec70b2$export$7a78f9e6092fd349);
        this.pageHero = (0, $db8fc88432e9d8af$export$543ec7a4a69e375a);
        this.solutionInsights = (0, $2ff7e82575b94e4c$export$df5af4369e5bf252);
        this.solutionOptions = (0, $cd5da2fb3520efb4$export$2a6f22bf2145b965);
        this.easyToDeploy = (0, $39ece5819af7acfa$export$159bc2be09fff49e);
        this.faq = (0, $a9543e944f7e4048$export$4bda925ccc2b533a);
        this.contactForm = (0, $7e5bb862242eb744$export$d5bd5b80f649d6c);
        this.fakeSendingOfContactForm = (0, $7e5bb862242eb744$export$f0b94daf0c371d49);
        this.aboutUsText1 = (0, $b0fd8fbdab86d582$export$c9d1c5c6e981c59a);
        this.autoTouchFormField = (0, $fa5ad37614750c0e$export$b3ec60d973020449);
    }
}
// @ts-ignore
window["Xploritas"] = new $3fe66f928c64cef1$export$510e4918aa4d8ee5();
// @ts-ignore
window["$"] = (0, $0dfdb7c551d2baa4$export$ef1639a4b889352d);
// @ts-ignore
window["$$"] = (0, $0dfdb7c551d2baa4$export$71aa6c912b956294);
// @ts-ignore
window["Alpine"] = (0, $cc64e8f951c5c19e$export$2e2bcd8739ae039);
(0, $0dfdb7c551d2baa4$export$ef1639a4b889352d)(()=>{
    (0, $cc64e8f951c5c19e$export$2e2bcd8739ae039).plugin((0, $9aeea8615f40f0fb$export$2e2bcd8739ae039));
    (0, $cc64e8f951c5c19e$export$2e2bcd8739ae039).start();
});

})();
//# sourceMappingURL=index.js.map
